import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyScreen from './happy';
import LunchScreen from './lunch';
import FootbalScreen from './footbal';
import BeersScreen from './beers';
import CategoriesScreen from './categories';
import HappyHourScreen from './happy';
import BrunchScreen from './brunch';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
    const [showbrunch, setShowBrunch] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showHappyHour, setshowHappyHour] = useState(false);
    const [showLunch, setshowLunch] = useState(false);
    const [showFootbal, setshowFootbal] = useState(false);
    const [showBeers, setshowBeers] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    const [steak, setSteak] = useState(false);
    const [tomahawk, settomahawk] = useState(false);
    const [dataDrinkns, setDataDrinks] = useState(false);
    const [dataMothers, setdataMothers] = useState(false);
    const [dataWings, setDataWings] = useState(false);

    const {
        goHomeInit
    } = useSelector((state) => state.initLoad);
        

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
            menus.map((item) => {
                if (item.id === 152) {
                setDataDrinks(item);
                }
            });
      }, [menus]);
    
    
     useEffect(() => {
    const categorieItem = menus.find((item) => item.id === 144);

    if (categorieItem) {
      const data = categorieItem.menus.find((item) => item.id === 1233);
      setDataWings(data);
    }
     }, [menus]);
    
    
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            setshowHappyHour(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowDetailProduct(false)
            setshowLunch(false)
            setshowFootbal(false)
            setshowBeers(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            setshowHappyHour(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
          setShowDetailProduct(false)
          setshowLunch(false)
          setshowFootbal(false)
          setshowBeers(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
            <div style={{background: "white", borderRadius: 30}}>
                <img
                        style={{
                            width: 390,
                            height: 150,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -60,
                              
                            marginLeft: 20,
                            
                        }}
                        src={require('./assets/66d32e2c9771f.jpg')}
                    />
  <br />
                     <br/>

                    <div
                        onClick={() => {
                            setshowBeers(true)
                        }}
                        style={{
                          
                        backgroundColor: '#217ED3',
                        padding: 10,
                        borderRadius: 13,
                            width: '85%',
                            margin: '0 auto',
                        position: 'relative'
                        }}>
                        {langEng ? (
                        <p
                            style={{
                            color: 'white',
                            textAlign: 'center',
                            fontSize: 36,
                            fontWeight: '400',
                            }}>
                            TAP HERE AND GET A <b>FREE</b> BEER
                         
                        </p>
                        ) : (
                        <>
                            <p
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: 26,
                                fontWeight: '400',
                            }}>
                            TAP AQUÍ Y CONSIGUE UNA <b>CERVEZA</b> GRATIS
                           
                            </p>
                        </>
                        )}

                        <img
                        style={{
                            width: 104,
                            height: 104,
                            position: 'absolute',
                            zIndex: 999,
                            right: -60,
                            top: -30,
                        }}
                        src={require('./assets/offert.png')}
                        />
                    </div>
                    
                    <br />
                     <br/>
                <div style={{ display: 'flex', width: '100%',  gap: 30,position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box' }}>
                       
                   
                    

                        <div style={{ width: '40%' }}
                        
                        onClick={() => {
                            setDataDish({ dish: dataWings, alldish: [], currentDish: dataWings })
                           setShowDetailProduct(true)
                        }}
                        >
                            <video
                             
                            src={require('./assets/video_wings.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 1,
                                width: '100%',
                                height: 438,
                                objectFit: 'cover',
                                borderRadius: 14,
                               
                               
                            }}
                        />

                        </div>
                        
                        <div style={{ width: '60%' }} >

                            <div
                                onClick={() => {
                                    setshowCategories(true)
                                }}
                                style={{backgroundColor: '#000000', borderRadius: 14}}>
                                <img
                                style={{
                                    width: '100%',
                                    height: 160,
                                    objectFit: 'cover',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/pizza.png')}
                                />
                                <p
                                style={{
                                    fontSize: 25,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    marginTop: 5,
                                    marginBottom: 5,
                                    color: 'white',
                                }}>
                                    {langEng ? 'TAP HERE FOR ' : 'TOCA AQUÍ PARA '}  <span style={{
                                    fontSize: 25,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    marginTop: 5,
                                    marginBottom: 5,
                                    color: '#71ade4',
                                    }}>
                                        {langEng ? 'FOOD' : 'COMIDA'}
                                </span>
                               
                                </p>
                            </div>

                            <div
                                onClick={() => {
                                    setdishs(dataDrinkns)
                                    setShowListProduct(true)

                                    
                                }}
                                style={{
                                backgroundColor: '#000000',
                                borderRadius: 14,
                                marginTop: 20,
                                }}>
                                <img
                                style={{
                                    width: '100%',
                                    height: 160,
                                    objectFit: 'cover',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/beers.png')}
                                />
                                <p
                                style={{
                                    fontSize: 25,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    marginTop: 5,
                                    marginBottom: 5,
                                    color: 'white',
                                }}>
                                {langEng ? 'TAP HERE FOR ' : 'TOCA AQUÍ PARA '}
                                <spam
                                    style={{
                                    fontSize: 25,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    marginTop: 5,
                                    marginBottom: 5,
                                    color: '#71ade4',
                                    }}>
                                    {langEng ? 'DRINKS' : 'BEBIDAS'}
                                </spam>
                                </p>
                            </div>
                    </div>
                </div>
               
                    
                   <div
                        style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                            width: '100%',
                            paddingInline: 20,
                        boxSizing: 'border-box'
                    }}>
                    <div
                   onClick={()=>setShowHappy(true)}
                    style={{
                        width: 200,

                        marginTop: 20,
                    }}>
                    <img
                        style={{
                        width: '100%',
                        height: 130,
                        objectFit: 'contain',
                        borderRadius: 14,
                        }}
                        src={require('./assets/happy.png')}
                    />
                    </div>
                        <div
                            onClick={()=>setshowLunch(true)}
                    style={{
                        width: 200,

                        marginTop: 20,
                    }}>
                    <img
                        style={{
                        width: '100%',
                        height: 130,
                        objectFit: 'contain',
                        borderRadius: 14,
                        }}
                        src={require('./assets/lunch.png')}
                    />
                    </div>
                 <div
                 onClick={()=>{setshowFootbal(true)}}
                           
                    style={{
                        width: 200,

                        marginTop: 20,
                    }}>
                    <img
                        style={{
                        width: '100%',
                        height: 130,
                        objectFit: 'contain',
                        borderRadius: 14,
                        }}
                        src={require('./assets/football.png')}
                    />
                    </div> 
                </div>
            </div>

            

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                {showHappyHour && <HappyScreen setShowListProduct={setshowHappyHour} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                {showbrunch && <BrunchScreen setShowBrunch={setShowBrunch} />}


                {showLunch && <LunchScreen setShowHappy={setshowLunch} />}
                {showFootbal && <FootbalScreen setShowHappy={setshowFootbal} />}
                {showBeers && <BeersScreen setShowHappy={setshowBeers} />}
                

                

                
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;